class CustomerDetailsController {

  $onInit () {
    this.initModel();
    this.model.selectedGuest = '';
  }

  initModel () {
    this.model = this.model || {};
  }

  useDetails (guest) {
    this.initModel();
    if (guest) {
      this.model.selectedGuest = guest;
    }

    if (this.model.selectedGuest) {
      this.model.first_name = this.model.selectedGuest.firstName || '';
      this.model.last_name = this.model.selectedGuest.lastName || '';
      this.model.email = this.model.selectedGuest.email || '';
      this.model.phone = this.model.selectedGuest.phone || '';
    }
  }

  isGuestSelected (guest) {
    this.initModel();
    return !!((this.model.integration_reference && this.model.integration_reference === guest.integrationReference) || (this.model.selectedGuest && this.model.selectedGuest.integrationReference === guest.integrationReference));
  }

  manualDetails () {
    this.initModel();
    this.model.selectedGuest = '';
    this.model.first_name = '';
    this.model.last_name = '';
    this.model.email = '';
    this.model.phone = '';
    this.model.integration_reference = null;
  }

  showManualDetails () {
    this.initModel();
    return !this.model.integration_reference && !this.model.selectedGuest;
  }

  notLoggedInDetails () {
    this.initModel();
    return !!(!this.model.selectedGuest ||
            (this.model.selectedGuest && !this.model.selectedGuest.loggedIn));
  }
}

CustomerDetailsController.$inject = [];

export default CustomerDetailsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/controllers/customer.details.controller.js